import { TranslationService } from '../../services/translate/translate.service';
import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject, input, signal } from '@angular/core';
import { CORPORATE_SITE_URL } from '../../constants/corporate';
import { SUPPORT_URL } from '../../constants/support';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';

import { MatButtonModule } from '@angular/material/button';
import { RentaDomains } from '../../models';

/**
 * Uses [TranslationService]{@link TranslationService} to control current language
 * and display available languages in dropdown.
 */
@Component({
  selector: 'rs-footer',
  templateUrl: './rs-footer.component.html',
  styleUrls: ['./rs-footer.component.scss'],
  imports: [TranslateModule, MatIconModule, MatMenuModule, MatButtonModule],
  providers: [TranslationService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RsFooterComponent {
  /** Translation-key for the "Disclaimer" text displayed,
   * component will automatically translate for given key
   *
   * Provide the translation-key in translation files
   * or override with self-defined translation-key */
  public disclaimerKey = input<string>('FOOTER.DISCLAIMER');
  /** Translation-key for the "Cookies" text displayed,
   * component will automatically translate for given key
   *
   * Provide the translation-key in translation files
   * or override with self-defined translation-key */
  public cookiesKey = input<string>('FOOTER.COOKIES');
  /** Translation-key for the "Need help?" text displayed,
   * component will automatically translate for given key
   *
   * Provide the translation-key in translation files
   * or override with self-defined translation-key */
  public needHelpKey = input<string>('FOOTER.NEED_HELP');

  public copyrightYear = signal<number>(new Date().getFullYear());
  public companyName?: string = RentaDomains.EUROPE_COPY;

  private readonly translate = inject(TranslationService);
  protected readonly currentLang = this.translate.currentLang;
  protected readonly currentLangLong = this.translate.currentLangLong;
  protected readonly languages = this.translate.languages;

  /**
   * Our corporate and support sites have no German pages, so German readers are sent to the
   * English ones. Every outbound link below composes its URL from this.
   */
  private readonly supportedSiteLang = computed(() => (this.currentLang() === 'de' ? 'en' : this.currentLang()));

  protected readonly disclaimerUrl = computed(() => `${CORPORATE_SITE_URL}/${this.supportedSiteLang()}/disclaimer`);
  protected readonly cookiesUrl = computed(() => `${CORPORATE_SITE_URL}/${this.supportedSiteLang()}/cookie-policy`);
  protected readonly supportLink = computed(() => `${SUPPORT_URL}/${this.supportedSiteLang()}/support/home`);

  /** @ignore */
  public setLanguage(language: { long: string; short: string }): void {
    this.translate.useLang(language.short);
  }
}
